// extracted by mini-css-extract-plugin
module.exports = {"Default":"withNotification_Default__1j2Wi","Body":"withNotification_Body__3dr1G"};